import { useFetch } from '@reveni-io/reveni-ui'

import configurationServices from '@/configuration/services/services'

import { transformResponseOrderTrackingPreview } from './transformers'

const useOrderTrackingPreview = ({ storeId }) => {
  const { data, fetchData } = useFetch(configurationServices.getOrderTrackingPreview, {
    doInitialRequest: true,
    params: { storeId },
    transformResponse: transformResponseOrderTrackingPreview,
  })

  const refreshOrderTrackingPreview = () => fetchData({ storeId })

  return { orderTrackingPreview: data, refreshOrderTrackingPreview }
}

export default useOrderTrackingPreview
